import * as React from 'react';
import { Component } from 'react';
import createStyles from '@material-ui/core/styles/createStyles';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import MenuItem from '@material-ui/core/MenuItem';
import { SelectValidator } from 'react-material-ui-form-validator';
import CircularProgress from '@material-ui/core/CircularProgress';
import PronounViewModel from '../ViewModels/PronounViewModel';

const styles = (theme: Theme) => createStyles({
    error: {
        color: "#FF0000",
    }
});


interface IPronounDropDownProps {
    setPronounDropDown?: (event) => void;
    pronoun: string | undefined;
    disabled: boolean;
}

interface IPronounDropDownState {
    model: PronounViewModel[];
    loaded: boolean;
}

class PronounDropDown extends Component<IPronounDropDownProps & WithStyles<typeof styles>, IPronounDropDownState> {
    constructor(props) {
        super(props);
        this.state = {
            model: [],
            loaded: false
        }
    }

    componentDidMount() {
        fetch('api/DropDown/GetPronouns').then(response => response.json()).then((data) => {
            this.setState({
                model: data,
                loaded: true,
            });
        });
    }

    public render() {
        let items: JSX.Element[] = [];

        if (this.state.model.length > 0) {
            items.push(<MenuItem key="defaultPronounVal" value={undefined}></MenuItem>);
            items = this.state.model.map(item =>
                <MenuItem key={item.value} value={item.value}>{item.display}</MenuItem>
            );
        }

        return (
            <SelectValidator
                label={"Preferred Pronoun"}
                name="pronoun"
                select
                fullWidth
                variant="outlined"
                margin="normal"
                value={this.props.pronoun}
                onChange={this.props.disabled ? undefined : this.props.setPronounDropDown}
                disabled={this.props.disabled}
                //validators={[]}
                //errorMessages={[]}
                InputProps={{
                    disabled: !this.state.loaded,
                    startAdornment: (
                        <React.Fragment>
                            {this.state.loaded ? null : <CircularProgress size={20} />}
                        </React.Fragment>
                    ),
                    readOnly: this.props.disabled
                }}
            >
                {items}
            </SelectValidator>
        );
    }
}

export default withStyles(styles)(PronounDropDown);